import { DELETE_API, GET_API, PATCH_API, POST_API } from "../../Functionalities/APIs";
import { partnerAdminPayoutsUrl, partnerPayoutOptionsUrl } from "../../Constants/apiUrls";

export const PAGE_SIZE = 20;

const toFormData = (fields) => {
  const data = new FormData();
  Object.entries(fields).forEach(([name, value]) => data.append(name, value ?? ""));
  return data;
};

const bodyOf = (result) => (result && result.data ? result.data : null);

export const payoutQuery = ({ branch, from, to, offset }) =>
  [
    `limit=${PAGE_SIZE}`,
    `offset=${offset || 0}`,
    branch ? `branch=${branch}` : "",
    from ? `from=${from}` : "",
    to ? `to=${to}` : "",
  ]
    .filter(Boolean)
    .join("&");

export const loadPayoutOptions = async () => bodyOf(await GET_API("", "", partnerPayoutOptionsUrl));

export const loadPayouts = async (filters) => bodyOf(await GET_API("", payoutQuery(filters), partnerAdminPayoutsUrl));

export const savePayout = async (payoutId, fields) =>
  bodyOf(
    payoutId
      ? await PATCH_API(toFormData(fields), "", `${partnerAdminPayoutsUrl}${payoutId}/`)
      : await POST_API(toFormData(fields), "", partnerAdminPayoutsUrl),
  );

export const deletePayout = async (payoutId) => bodyOf(await DELETE_API("", "", `${partnerAdminPayoutsUrl}${payoutId}/`));
